export const isEmbedded = () => !!(window as any).mchObserver;
export const closeWebView = () => (window as any).mchObserver.postMessage("closeWebView");
export const isMobileBrowser = () => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    return /android|iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
};
